jQuery(document).ready(function($) {

  $('.filter-menu-toggle').click(function(event){
    event.preventDefault();
    $('.sticky').toggleClass('expanded');
  });

  if ($('body').hasClass('single')) {
    $('.entry-content p img').each(function(){
      $(this).remove();
    });

    $('.entry-content .gallery').each(function(){
      $(this).remove();
    });
  }

  if ($('body').hasClass('home')) {
    // eslint-disable-next-line no-undef
    var featuredSwiper = new Swiper ('.swiper-container-featured', {
      // Optional parameters
      loop: true,
      autoplay: {
        delay: 5000,
      },
      speed: 1000,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

    });
  }

  if ($('body').hasClass('home') || $('body').hasClass('category') || $('body').hasClass('page-template-template-sold-items') || $('body').hasClass('search')) {
    $(function(){
    
      var $container = $('#isotope-container');

      $container.isotope({
        itemSelector : '.grid-item',
        percentPosition: true,
        isInitLayout: true,
        masonry: {
          columnWidth: '.grid-sizer',
          gutter: '.gutter-sizer'
        }
      });

      // layout Isotope after each image loads
      $container.imagesLoaded().progress( function() {
        $container.isotope('layout');
      });

    });

    // Infinite Scroll
    $('#isotope-container').infinitescroll({
        navSelector: 'div.pagination',
        nextSelector: 'div.pagination a:first',
        itemSelector: '.grid-item',
        bufferPx: 200,
        loading: {
            finishedMsg: 'We\'re done here.',
            //img: +templateUrl+'ajax-loader.gif'
        },
    },

    // Infinite Scroll Callback
    function (newElements) {
        var $newElems = jQuery(newElements).hide();
        $newElems.imagesLoaded(function () {
            $newElems.fadeIn();
            $('#isotope-container').isotope('insert', $newElems);
        });
    });

  } // End Isotope page scripts

}); // End document.ready